// <dvm-carousel>: horizontal product row with previous / next arrows.
// A custom element so it also works in sections Shopify injects after load (product recommendations).
if (!customElements.get('dvm-carousel')) {
  customElements.define(
    'dvm-carousel',
    class DvmCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dvm-carousel__track');
        this.prev = this.querySelector('[data-dvm-prev]');
        this.next = this.querySelector('[data-dvm-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.update = this.update.bind(this);
        // In right-to-left pages "next" scrolls towards the left and scrollLeft runs from 0 to negative values.
        this.sign = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.prev.addEventListener('click', () => this.track.scrollBy({ left: -this.step() * this.sign, behavior: 'smooth' }));
        this.next.addEventListener('click', () => this.track.scrollBy({ left: this.step() * this.sign, behavior: 'smooth' }));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      step() {
        const item = this.track.querySelector('li');
        if (!item) return this.track.clientWidth;
        return item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      }

      update() {
        const pos = Math.abs(this.track.scrollLeft);
        this.prev.hidden = pos < 8;
        this.next.hidden = pos + this.track.clientWidth >= this.track.scrollWidth - 8;
      }
    }
  );
}
